import type { ContextMenuItem } from "../types/contextMenu.types";

export function resolveBoolean<TContext>(
    value: boolean | ((context: TContext) => boolean) | undefined,
    context: TContext,
): boolean {
    if (typeof value === "function") {
        return value(context);
    }

    return Boolean(value);
}

export function isMenuItemHidden<TContext>(
    item: ContextMenuItem<TContext>,
    context: TContext,
): boolean {
    if (item.type === "separator") {
        return false;
    }

    return resolveBoolean(item.hidden, context);
}

export function isMenuItemDisabled<TContext>(
    item: ContextMenuItem<TContext>,
    context: TContext,
): boolean {
    if (item.type === "separator") {
        return true;
    }

    return resolveBoolean(item.disabled, context);
}

export function getVisibleMenuItems<TContext>(
    items: ContextMenuItem<TContext>[],
    context: TContext,
): ContextMenuItem<TContext>[] {
    return items.filter((item) => !isMenuItemHidden(item, context));
}

export function hasVisibleSubmenuItems<TContext>(
    item: ContextMenuItem<TContext>,
    context: TContext,
): boolean {
    if (item.type !== "submenu") {
        return false;
    }

    return getVisibleMenuItems(item.items, context).length > 0;
}